// Copyright 2026 The OpenAgent Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import * as Setting from "../Setting";

export function getToolPolicies(owner, page = "", pageSize = "", field = "", value = "", sortField = "", sortOrder = "") {
  return fetch(`${Setting.ServerUrl}/api/get-tool-policies?owner=${owner}&p=${page}&pageSize=${pageSize}&field=${field}&value=${value}&sortField=${sortField}&sortOrder=${sortOrder}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => Setting.handleFetchResponse(res));
}

export function getToolPolicy(owner, name) {
  return fetch(`${Setting.ServerUrl}/api/get-tool-policy?id=${owner}/${encodeURIComponent(name)}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
  }).then(res => Setting.handleFetchResponse(res));
}

export function updateToolPolicy(owner, name, toolPolicy) {
  const newToolPolicy = Setting.deepCopy(toolPolicy);
  return fetch(`${Setting.ServerUrl}/api/update-tool-policy?id=${owner}/${encodeURIComponent(name)}`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
    body: JSON.stringify(newToolPolicy),
  }).then(res => Setting.handleFetchResponse(res));
}

export function addToolPolicy(toolPolicy) {
  const newToolPolicy = Setting.deepCopy(toolPolicy);
  return fetch(`${Setting.ServerUrl}/api/add-tool-policy`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
    body: JSON.stringify(newToolPolicy),
  }).then(res => Setting.handleFetchResponse(res));
}

export function deleteToolPolicy(toolPolicy) {
  const newToolPolicy = Setting.deepCopy(toolPolicy);
  return fetch(`${Setting.ServerUrl}/api/delete-tool-policy`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Accept-Language": Setting.getAcceptLanguage(),
    },
    body: JSON.stringify(newToolPolicy),
  }).then(res => Setting.handleFetchResponse(res));
}
